'use strict';

//external
import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Col } from 'external/react-bootstrap';

/**
 * Generic Errormessage to choose an object
 * @param element
 */
const SelectObjectErrorMessage = ({ content }) => {

    return (
        <div className="error-message">{content}</div>
    )
};

SelectObjectErrorMessage.propTypes = {
    content: PropTypes.string.isRequired
};

export default SelectObjectErrorMessage;



// WEBPACK FOOTER //
// ./js/components/SelectObjectErrorMessage.jsx